<div class="modal-content">
  <div class="modal-header">
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="closeModal()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <h5 class="modal-title heading-6" id="modal-basic-title">
      {{ "company.company-form.external" | translate }}
    </h5>
    <form
      [formGroup]="form"
      [ngClass]="{ 'loading-background': loading }"
      (ngSubmit)="onSubmit()"
    >
      <div class="row">
        <div class="col-12 d-flex justify-content-end flex-column">
          <div class="form-group">
            <label *ngIf="departments" for="group">{{
              "common.choose-group" | translate
            }}</label>
            <select
              *ngIf="departments"
              class="form-control icon-arrow-rtl"
              formControlName="group"
              id="group"
              (change)="onGroupChange($event.target.value)"
            >
              <option *ngFor="let group of departments" [value]="group.uuid">
                {{ group.name }}
              </option>
            </select>
            <label for="policy">
              {{ "common.policies.select-policy-custom" | translate }}
            </label>
            <select
              class="form-control icon-arrow-rtl"
              formControlName="policy"
              id="policy"
            >
              <option *ngFor="let p of policies" [value]="p.uuid">
                {{ p.name }}
              </option>
            </select>
            <label for="emails">{{
              "company.company-form.externalPlease" | translate
            }}</label>
            <mat-form-field class="example-chip-list">
              <mat-chip-list #chipList aria-label="Email">
                <mat-chip
                  *ngFor="let email of emails"
                  [selectable]="selectable"
                  [removable]="removable"
                  (removed)="remove(email)"
                >
                  {{ email }}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
              </mat-chip-list>
              <input
                [readOnly]="loading"
                formControlName="emails"
                type="email"
                class="form-control rounded-1"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="addOnBlur"
                (matChipInputTokenEnd)="add($event)"
              />
            </mat-form-field>
            <!-- <input [readOnly]="loading" formControlName="emails" type="email" id="emails"
            class="form-control rounded-1" /> -->
            <div class="form-group">
              <label for="accessType">{{ "common.access-type" | translate }}</label>
              <select
                class="form-control icon-arrow-rtl"
                formControlName="accessType"
                id="accessType"
              >
                <option *ngFor="let type of availableAccessTypes" [value]="type">
                  {{ ('common.' + type + '-type') | translate }}
                </option>
              </select>
              <div *ngIf="!accessTypeValid" class="text-danger" style="font-size: small">
                {{ "company.access-type-warning" | translate }}
              </div>
            </div>
            <div class="form-group mt-3">
              <label style="margin-top: 1rem !important;" for="notificationsSelect">{{ "user.notifications.title" | translate }}</label>
              <mat-form-field appearance="outline" floatLabel="never" class="full-width">
                <mat-select
                  id="notificationsSelect"
                  formControlName="notificationsTargets"
                  multiple
                  panelClass="custom-scroll"
                >
                  <mat-select-trigger>{{ notificationsTrigger }}</mat-select-trigger>
                  <mat-option
                    *ngFor="let opt of notificationOptions"
                    [value]="opt.value"
                    (onSelectionChange)="onNotifOptionToggle($event)"
                  >
                    {{ opt.labelKey | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <button
            class="custom-btn"
            ngbAutofocus
            mat-button
            [disabled]="!form.valid || loading || !accessTypeValid"
          >
            {{ "common.send" | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
